<div *ngIf="peopleYouMayKnow?.length || fetching">
    <div class="text-lg font-semibold md:text-xl mb-5">People You May Know</div>

    <nz-skeleton *ngIf="fetching" [nzActive]="true"></nz-skeleton>

    <div *ngIf="peopleYouMayKnow?.length" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        <app-user-card *ngFor="let item of peopleYouMayKnow" [userInfo]="item"></app-user-card>
    </div>
</div>
